module.exports = __webpack_public_path__ + "img/ecommerce-app.618a5079.png";